const baseURL = `${process.env.REACT_APP_BASE_URL}/api/websites`

let headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to validate domain
const editDomainNameAPI = async (
    token:string,
    id:number,
    websiteURL: string,
    temporary_domain?: string,
): Promise<any> => {
    let url = `${baseURL}/update`;

    const Formdata = new FormData();
    Formdata.append("url", websiteURL);
    Formdata.append("id", id.toString());
    if (temporary_domain) {
        Formdata.append("temporary_domain", temporary_domain);
    }
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body: Formdata
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export { editDomainNameAPI }